// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/tires/price-and-shop.scss
// module id = 1361
// module chunks = 10